// src/api/features/hotel-bookings/api.ts

import { request } from "@/api/client";
import { PATHS } from "@/api/constants";

import type { AdminHotelCancellationOverview, AdminHotelVoucher } from "./types";

type ApiEnvelope<T> = { ok: boolean; message?: string; data: T };

function unwrap<T>(res: ApiEnvelope<T> | T): T {
  if (res && typeof res === "object" && "ok" in res && "data" in res) {
    return (res as ApiEnvelope<T>).data;
  }
  return res as T;
}

const HOTEL = PATHS.hotelBookingsAdmin;

/** The booking as operations sees it: voucher + supplier, cost and margin. */
export async function adminGetHotelVoucher(bookingId: number | string): Promise<AdminHotelVoucher> {
  const res = await request<ApiEnvelope<AdminHotelVoucher>>({
    method: "GET",
    url: HOTEL.voucher(bookingId),
  });
  return unwrap(res);
}

/** Cancellation eligibility, estimate and the latest attempt (re-polls the supplier when pending). */
export async function adminGetHotelCancellation(
  bookingId: number | string
): Promise<AdminHotelCancellationOverview> {
  const res = await request<ApiEnvelope<AdminHotelCancellationOverview>>({
    method: "GET",
    url: HOTEL.cancellation(bookingId),
  });
  return unwrap(res);
}

export async function adminCancelHotelBooking(
  bookingId: number | string,
  body: { reason: string }
): Promise<AdminHotelCancellationOverview> {
  const res = await request<ApiEnvelope<AdminHotelCancellationOverview>>({
    method: "POST",
    url: HOTEL.cancel(bookingId),
    data: body,
  });
  return unwrap(res);
}
